<template>
  <div>
    <v-app-bar
      dense
      flat
      height="50"
    >
      <v-row align="center">
        <v-col
          xs="12"
          sm="5"
          md="4"
          class="d-none d-sm-flex"
        >
          <search-field
            :search-text="searchText"
            :status="status"
            @statusChange="changeStatus"
            @search="onSearch"
          />            
        </v-col>
        <v-col
          xs="12"
          sm="7"
          md="8"
          align="end"
        >
          <v-btn
            id="user_refresh"
            color="primary"
            :loading="loader"
            class="mr-2 elevation-0"
            @click.native="reload()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <create-form
            :user-id="selectedUserId"
            :open.sync="userForm"
            @refresh="reload"
          />
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                id="user_add"
                slot="activator"
                class="elevation-0"
                color="success"
                @click="openUserForm()"
                v-on="on"
              >
                <v-icon>mdi-plus</v-icon> User
              </v-btn>
            </template>
            <span>Create a new user</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card
      flat
      outlined
      tile
    >
      <v-card-text>
        <v-row>
          <v-col
            xs="12"
            class="d-flex d-sm-none"
          >
            <search-field
              :search-text="searchText"
              :status="status"
              @statusChange="changeStatus"
              @search="onSearch"
            />            
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-divider></v-divider>
        </v-row> -->
        <v-row>
          <v-col
            v-for="user in users"
            :key="`user-list--${user.id}`"
            cols="12"
            sm="4"
            lg="3"
            xl="2"
            class="d-flex"
          >
            <v-card
              class="mx-auto"
              flat
              outlined
            >
              <v-card-text
                style="cursor: pointer"
                @click="openUserForm(user.id)"
              >
                <v-row justify="end">
                  <v-col cols="auto">
                    <user-options
                      :user-id="user.id"
                      :active="user.activeStatus"
                      @reload="getUsers()"
                    />
                  </v-col>
                </v-row>
                <v-row
                  class="text-center"
                  no-gutters
                >
                  <v-col
                    cols="12"
                    class="text-h5"
                  >
                    {{ user.name }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="subtitle-1"
                  >
                    {{ user.email }}
                  </v-col>
                  <v-col
                    cols="12"
                    class="subtitle-1"
                  />
                </v-row>
              </v-card-text>

              <v-divider class="mt-2 mx-4" />

              <v-card-actions>
                <v-row justify="center">
                  <v-col
                    v-if="user.isAdmin || user.role"
                    cols="auto"
                  >
                    <v-chip
                      outlined
                      label
                      color="success--text"
                    >
                      {{ user.isAdmin ? "ADMIN*" : user.role.name }}
                    </v-chip>
                  </v-col>
                  <v-col cols="auto">
                    <v-chip
                      v-if="user.activeStatus"
                      outlined
                      label
                      color="success--text"
                    >
                      Active
                    </v-chip>
                    <v-chip
                      v-else
                      outlined
                      label
                      color="error--text"
                    >
                      In-active
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-show="totalPage > 1">
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="totalPage"
              @input="getUsers()"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { failure, pagination } from "@/mixins/common";
import UserOptions from "@/components/user/UserOptions";
import CreateForm from "@/components/user/UserForm";
import SearchField from "@/components/utils/SearchField";

export default {
  name: "UserList",
  components: {
    UserOptions,
    CreateForm,
    SearchField
  },
  mixins: [failure, pagination],
  data() {
    return {
      loader: false,
      users: [],
      searchText: null,
      page: 1,
      totalPage: 0,
      status: "",
      userForm: false,
      selectedUserId: 0
    };
  },
  created() {
    this.init();
  },
  methods: {
    getUsers() {
      this.loader = true;
      let url = `${this.ADMIN_API_URL}/users?page=${
        this.page - 1
      }&sort_key=name&limit=${this.limit}&status=${this.status}`;
      if (this.searchText) {
        url += `&search=${this.searchText}`;
      }
      this.$http.get(url).then(
        (res) => {
          this.users = res.body.data || [];
          this.totalPage = res.body.totalPage;
          this.page = res.body.pagination.page + 1;
          this.loader = false;
        },
        (failure) => {
          this.handleFailure(failure);
        }
      );
    },
    search() {
      this.page = 1;
      this.getUsers();
    },
    reload() {
      this.searchText = null;
      this.status = "";
			this.search();
		},
    onSearch(val) {
      this.searchText = val;
      if (!val || val.length >= 3) {
        this.search();
      }
    },
		changeStatus(status) {
			this.status = status;
			this.search();
    },
    openUserForm(id = 0) {
      this.selectedUserId = id;
      this.userForm = true;
    },

    init() {
      this.getUsers();
    }
  }
};
</script>
